module.exports = function getResource(label) {
    let resources = {
        giftCardMessage: 'Ce message sera imprimé et inclus avec votre carte-cadeau.'
    };

    return resources[label];
};
